module.exports = __webpack_public_path__ + "static/media/simplonbp-regular-webfont.ea21f3d9.eot";